<script lang="ts">
	import Row from './Row.svelte'

	interface Props {
		row: Record<string, string>
		key: string
		editableEnabled: boolean
		shouldHighlightCurlyBraces?: boolean
		onsubmit: ((row: Record<string, string>) => void) | null
		onfocus: (() => void) | null
		onblur: (() => void) | null
		onstartediting?: (() => void) | null
	}

	let {
		row,
		key,
		editableEnabled,
		shouldHighlightCurlyBraces = false,
		onsubmit = null,
		onfocus = null,
		onblur = null,
		onstartediting = null
	}: Props = $props()
</script>

<div class="label">
	<Row
		{editableEnabled}
		{row}
		column={key}
		{shouldHighlightCurlyBraces}
		{onblur}
		{onfocus}
		{onsubmit}
		{onstartediting}
	/>
</div>

<style>
	.label {
		font-family: 'inter', sans-serif;
		font-size: 16px;
		font-weight: 400;
		line-height: 23px;
		color: #606266;
	}
</style>
